<template>
  <tile class="opc-addon-config">
    <foldable v-model="isExpanded" :arrow="hasSelectedPlan" :edit="hasSelectedPlan" :title="title">
      <div slot="head" class="opc-zm-base-card__head">
        <div class="opc-zm-base-card__head-left">
          <img :src="logo" class="opc-zm-base-card__logo" :alt="title + ' Icon'" tabindex="-1" />
        </div>
        <div class="opc-zm-base-card__head-right">
          <h2 class="opc-zm-base-card__name text-capitalize">
            <span :class="[isAdd2CartOrEditFlow ? 'opc-addon-config__title--add' : '']">{{
              title }}</span>
            <i v-if="hasSelectedPlan && !isAdd2CartOrEditFlow" check-icon class="zm-icon-success main-icon" aria-hidden="true" />
          </h2>
          <!-- TODO: optimize style -->
          <div v-if="hasSelectedPlan && !isExpanded && isAdd2CartOrEditFlow"
            class="opc-zm-base-card__collapse opc-zm-base-card__collapse--reset">
            <storage-content :selected-plan="selectedPlan" />
          </div>
          <div v-if="!isAdd2CartOrEditFlow && !isExpanded" slot="collapse"
            class="opc-zm-base-card__collapse opc-zm-base-card__collapse--reset">
            <storage-content v-if="hasSelectedPlan" :selected-plan="selectedPlan" />
          </div>
        </div>
      </div>
      <div class="divide-line"></div>
      <div class="opc-addon-config__main ldk-cmr">
        <p class="opc-addon-config__main__title">{{ $t('billing.cmr_ldk.intro') }}
          <zm-tooltip class="opc-addon-config-row--tips" popper-class="sdk-cmr-tips"
              :aria-label="`Lear`" placement="bottom">
              <div slot="content" v-html="tips" />
              <i role="button" style="margin-left: 4px;" class="zm-icon-info-outline" @mouseover="showTooltip"/>
            </zm-tooltip>
          </p>
        <zm-radio-group :value="selectedPlanCode" :enter-select="true" @input="onPlanSelect" ref="radioGroup"
          aria-label="Select a capacity" class="opc-addon-config__main__plan opc-card-radio">
          <zm-radio data-testid="checkout-radio-67" v-for="plan in planList" :key="plan.plan_code" :label="plan.plan_code" :class="planList.length === 1? 'zoom-radio-single':''">
            <p class="opc-addon-config__main__plan__capacity">
              <span>{{ plan.cartCapacity }} {{ plan.cartCapacityUnit }}</span>
              <CycleCurrentBadge :value="plan" />
            </p>
            <p class="opc-addon-config__main__plan__price">
              <span class="opc-addon-config__main__plan__price--amount">{{ $money(plan.amount, { forceDiff: true })
              }}</span>
              <span class="opc-addon-config__main__plan__price--unit">{{
                $t(`billing.common.per_billing_cycle.${plan.billing_cycle}`) }}<priceVATTip />
                </span>
            </p>
          </zm-radio>
        </zm-radio-group>
        <div class="opc-zm-base-card__main__footer">
          <div class="opc-zm-base-card__btn--wrap">
            <zm-button data-testid="checkout-button-68" v-if="!isAdd2CartOrEditFlow && canRmv" type="link" ghost @click="removePlanByKey"
              :aria-label="'remove ' + title + ' plan'">{{ $t('billing.common.remove') }}</zm-button>
          </div>
        </div>
        <preview-payment class="opc-addon-config__preview-payment" />
      </div>
    </foldable>
  </tile>
</template>

<script>
import { get } from "lodash";
import CMRCommon from './mixin';
import Foldable from '@/components/foldable.vue';
import Tile from '@/components/tile.vue';
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import StorageContent from './components/storage-content.vue';
import { planTypes, trackingPlanTypes } from '@/common/constants';
import plansMixin from '@/plans/mx/plan';
import { translation } from '@/plugins/i18n';
import { pageConfig } from '@/common/service/page-config';
import PreviewPayment from '@/views/checkout/payment/preview-payment';
import CycleCurrentBadge from '@/components/service/config-billing-cycle/cycle-current-badge.vue';

export default {
  name: 'LDKCMR-Config',
  mixins: [CMRCommon, plansMixin],
  components: {
    PreviewPayment,
    Foldable,
    Tile,
    StorageContent,
    CycleCurrentBadge,
  },
  data() {
    return {
      isExpanded: true,
      billingCycle: '',
      selectedPlanCode: '',
    };
  },
  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters(['getSelectedPlans', 'basicConfig']),
    planList() {
      return this.planMapFlat.filter((p) => p.type === planTypes.LDKCMR);
    },
    selectedPlan() {
      return this.planList.find((item) => item.plan_code === this.selectedPlanCode);
    },
    cartSelectedPlan() {
      return get(this.getSelectedPlans.filter((p) => p.type === planTypes.LDKCMR), [0]);
    },
    hasSelectedPlan() {
      return !!this.selectedPlanCode;
    },
    capacityText(){
      const { capacity } = this.planList[0]
      return this.getCapacityText(capacity)
    },
    editPlanListTipsTxt(){
      return this.planList.map(k=> [this.getCapacityText(k.capacity),k.excessPrice,k.minuteExcessPrice])
    },
    tips(){
      const {minuteCapacity, excessPrice, minuteExcessPrice } = this.planList[0]
      return `${translation('billing.cmr_ldk.tips_base')} <br />`+
              (this.$context.is.edit?
              `${translation('billing.cmr.important_tips')}<br />
                 ${translation('billing.cmr_ldk.tips_tb_2',this.editPlanListTipsTxt[0])} <br />
                 ${translation('billing.cmr_ldk.tips_tb_2',this.editPlanListTipsTxt[1])}`
                :
              `${translation('billing.cmr_ldk.tips', [
                  this.capacityText,
                  minuteCapacity,
                ])}<br />
                - ${translation('billing.cmr_ldk.tips_2',[excessPrice])} <br />
                - ${translation('billing.cmr_ldk.tips_3',[minuteExcessPrice])}`)
    },
    canRmv(){
      return this.isShowRemoveBtn
    },
  },
  methods: {
    ...mapMutations(['updateSelectPlan', 'removePlan']),
    ...mapActions(['switchSelectPlan']),
    onPlanSelect(newPlanCode) {
      const oldPlanCode = this.selectedPlanCode;

      if (this.selectedPlanCode !== newPlanCode) {
        if (oldPlanCode) {
          this.switchSelectPlan([oldPlanCode, newPlanCode, undefined]);
        } else {
          this.updateSelectPlan({
            plan_code: newPlanCode,
            cartInfo: { selected_number: 1 },
          });
        }
        this.selectedPlanCode = newPlanCode;
      }

      const plan = this.planList?.find((plan) => plan.plan_code === newPlanCode);
      plan && this.$tracking.addOnBuyInteraction(trackingPlanTypes.LDKCMR, `${plan?.cartCapacity}${plan?.cartCapacityUnit}`);
    },
    onPlanRemove() {
      this.removePlan(this.selectedPlanCode);
      this.selectedPlanCode = '';
    },
    // For A11Y
    getFirstFocusableControl() {
      let firstRadioEl = this.$refs.radioGroup.$el.querySelector('.zm-radio').querySelector('input[type="radio"]');
      return Promise.resolve(firstRadioEl);
    },
    getCapacityText(number) {
      const suffix = {
        gb: ' GB',
        tb: ' TB',
      };
      if (number < 1024) {
        return number + suffix.gb;
      } else {
        return number / 1024 + suffix.tb;
      }
    },
    showTooltip() {
      this.$tracking.buyInteraction('video sdk pay as you go add-ons',`${this.trackingPlanKey} - ${this.capacityText} -  tooltip`)
    },
    collapseCard() {
      this.isExpanded = false;
    },
  },
  watch: {
    cartSelectedPlan: {
      immediate: true,
      handler(plan) {
        this.selectedPlanCode = plan?.plan_code ?? "";
      },
    },
    isExpanded: {
      handler(val) {
        this.$tracking.addOnBuyInteraction('sdk recording accordion', val ? 'expand' : 'collapse');
      },
    },
  },
  mounted(){
    const oldPlanCode = pageConfig?.oldPlanCode;
    if(oldPlanCode === 'ldkcmr_3TB_monthly'){
      this.onPlanSelect('ldkcmr_5TB_monthly')
    }
    if(!oldPlanCode && this.$context.is.buyNow){
      this.onPlanSelect('ldkcmr_1TB_monthly')
    }
    this.$context.$on('collapse-plan-card', this.collapseCard);
  },
};
</script>

<style lang="scss">
@import '@/styles/zoom-card.scss';
@import '@/styles/plans/addon-config.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.ldk-cmr {
  .zm-radio {
    &.zm-radio-single{
      flex: 0 0 calc(100% - 8px);
    }

    flex: 0 0 calc(100% - 8px);
  }
}

.opc-addon-config {
  &__title {
    font-weight: 500;
    font-size: 14px;
    color: #515079;

    i[check-icon] {
      font-size: 16px;
      color: #0B5CFF;
      margin-left: 12px;
    }

    &-content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
    }
  }

  .opc-addon-config__subtitle {
    display: flex;
    align-items: center;

    ul {
      margin-left: 16px;
      display: flex;
      align-items: center;

      li span,
      li label {
        font-size: 14px;
        font-weight: 500;
        line-height: 120%;
        margin-left: 0;
        color: #00053D;
      }

      &>li:not(:first-child)::before {
        content: "•";
        margin: 0 10px;
      }
    }

    &-current {
      color: #6E7680;
      font-weight: 500;
      font-size: 14px;
      line-height: 120%;
      margin-right: 2px;
      text-transform: initial;
    }

    &-used {
      color: #131619;
      margin-left: 0;
      margin-right: 2px;
      font-weight: 500;
      font-size: 14px;
      line-height: 120%;
      text-transform: initial;
    }

    &-overage {
      color: #B36200;
      margin: 0;
      font-weight: 500;
      font-size: 14px;
      line-height: 120%;
      text-transform: initial;
    }
  }

  &__main {
    &__plan {
      display: flex;
      flex-wrap: wrap;
      margin-top: 24px;
      color: #00053D;

      .zm-radio {

        &__wrap {
          width: 100%;
        }

        &__label {
          &--inner {
            width: 100%;
          }

          &.is-disabled {

            .opc-addon-config__main__plan__price--amount,
            .opc-addon-config__main__plan__price--unit {
              color: #9191A4;
            }
          }
        }
      }

      &__capacity,
      &__price {
        line-height: 150%;
      }

      &__capacity {
        font-weight: 700;
        font-size: 16px;
        display: flex;
        align-items: center;

        &-recommend {
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(96.59deg, #084845 10.36%, #09A639 89.64%);
          border-radius: 100px;
          padding: 0px 8px;
          color: #FFFFFF;
          font-weight: 400;
          font-size: 12px;
          line-height: 16px;
          margin-left: 8px;
        }
      }

      &__price {
        font-weight: 450;
        font-size: 22px;

        &--amount {
          font-size: 22px;
          font-weight: 700;
          color: #00053D;
        }

        &--unit {
          font-size: 12px;
          font-weight: 500;
          color: #515079;
        }
      }
    }

    &__footer {
      margin-top: 24px;

      &--tips {
        font-weight: 500;
        font-size: 12px;
        color: #747487;
        text-align: left;
        line-height: 150%;
      }
    }

      .zm-icon-info-outline {
        color: #0B5CFF;
        font-size: 14px;
      }

  }

  &__btn {
    &--wrap {
      margin-top: 24px;

      .zm-button {
        padding: 0px;
      }
    }
  }

  .opc-common-info-alert.zm-alert {
    background: #FEF7D9;
    padding: 16px;

    .zm-icon-warning {
      margin-right: 16px;

      &::before {
        content: "";
        background-image: url('../../assets/Alert.svg');
        width: 16px;
        height: 16px;
        background-repeat: no-repeat;
        background-size: cover;
        display: inline-block;
      }
    }
  }

  &__preview-payment {
    margin-top: 24px;
  }

}


.sdk-cmr-tips{
 min-width: 650px;
 @include media(mobile,tablet){
  min-width: auto;
 }
}
</style>
